import React from 'react';
import s from './LogoLoader.scss';

function LogoLoader({ size = 'medium' }) {
  return (
    <div className={`${s.logoLoader} ${s[size]}`}>
      <div className={s.logoContainer}>
        <svg viewBox="0 0 71.94 40">
          <polygon
            points="25.97 22.34 20.21 22.34 23.09 13.7 25.97 22.34"
            fill="currentColor"
            className={s.logoAccentFill}
          />
          <path
            d="M58.55,0,48.74,26,38.7,0H25.25V12L29.56,25H25.25V40H36.37V17.76L44,40h9.31l7.54-22.07V40H71.94V0Z"
            fill="currentColor"
            className={s.logoMFill}
          />
          <polygon
            points="20.93 12.03 16.68 24.97 20.93 24.97 20.93 33.47 13.84 33.47 11.69 40 0 40 14.58 0 20.93 0 20.93 12.03"
            fill="currentColor"
            className={s.logoAFill}
          />
        </svg>
      </div>
    </div>
  );
}

export default LogoLoader;
